<template>
  <div class="w-full sm:w-[280px] lg:w-[300px] mx-auto sm:mx-0">
    <div class="bg-white rounded-xl sm:rounded-2xl shadow-lg p-5 sm:p-6">
      <h3
        class="text-lg sm:text-xl font-bold text-gray-700 mb-4 sm:mb-6 pb-2 sm:pb-3 border-b border-gray-200"
      >
        profile
      </h3>

      <div class="text-center mb-5 sm:mb-6">
        <img
          :src="require('../assets/pictures/avatar.jpg')"
          alt="Avatar"
          class="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 rounded-full mx-auto shadow-md hover:scale-105 transition-transform"
        />
        <p class="mt-3 sm:mt-4 text-base sm:text-lg font-medium text-gray-800">
          Hlly1
        </p>
      </div>

      <nav class="space-y-1 sm:space-y-2">
        <a
          href="#"
          class="flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 no-underline group"
        >
          <HomeIcon
            class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500 group-hover:text-blue-500 transition-colors flex-shrink-0"
          />
          <span class="text-xs sm:text-sm">Home</span>
        </a>
        <a
          href="https://baike.baidu.com/item/%E4%B8%94%E5%90%AC%E9%A3%8E%E5%90%9F"
          target="_blank"
          class="flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 no-underline group"
        >
          <PlanetIcon
            class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500 group-hover:text-blue-500 transition-colors flex-shrink-0"
          />
          <span class="text-xs sm:text-sm">About Me</span>
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import { defineComponent, h } from "vue";
import { HomeOutline, PlanetOutline } from "@vicons/ionicons5";

const HomeIcon = defineComponent({
  render() {
    return h(HomeOutline);
  },
});

const PlanetIcon = defineComponent({
  render() {
    return h(PlanetOutline);
  },
});

export default defineComponent({
  name: "SiderProfile",
  components: {
    HomeIcon,
    PlanetIcon,
  },
});
</script>
